<template>
  <div class="lenovoPartCode">
    <el-table stripe :data="tableData" border style="width: 100%" height="100%" size="mini">
      <el-table-column type="index" :width="pagination.endIndex >= 1000 ? 80 : 50"
        align="center" :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column prop="partType" label="配件类型" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.partType || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="partName" label="配件名称" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.partName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="partCode" label="配件编码" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.partCode || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300">
            <i @click="handleEdit(scope.row)" class="el-icon-edit" style="cursor: pointer;"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="onSearch"
    ></pagination>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="配件类型：" size="small" prop="partType">
            <el-input v-model="dialogForm.partType" placeholder="输入配件类型" clearable></el-input>
          </el-form-item>
          <el-form-item label="配件名称：" size="small" prop="partName">
            <el-input v-model="dialogForm.partName" placeholder="输入配件名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="配件编码：" size="small" prop="partCode">
            <el-input v-model="dialogForm.partCode" placeholder="输入配件编码" clearable></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiLenovoPartCodeSearch,
  apiLenovoPartCodeAdd,
  apiLenovoPartCodeUpdate,
  apiLenovoPartCodeDelete,
  apiLenovoPartCodeExport,
} from "@/api/itemCodeManage.js";
export default {
  components: {
    pagination,
    myDialog,
  },
  props: {
    lenovoPartCodeSearchForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {
        partCode: [
          { required: true, message: "配件编码不能为空！", trigger: "blur" },
        ],
        partName: [
          { required: true, message: "配件名称不能为空！", trigger: "blur" },
        ],
        partType: [
          { required: true, message: "配件类型不能为空！", trigger: "blur" },
        ],
      },
      labelWidth: "110px",
    };
  },
  methods: {
    // 表格数据
    async onSearch() {
      this.tableData = [];
      const res = await apiLenovoPartCodeSearch({
        ...this.lenovoPartCodeSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      });
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
      }
    },
    // 新建
    addNew() {
      this.dialogTitle = "新建联想配件编码";
      this.dialogForm = {};
      this.$refs.myDialog.dialogVisible = true;
    },
    // 修改
    handleEdit(row) {
      this.dialogTitle = "修改联想配件编码";
      this.dialogForm = {
        id: row.id,
        partCode: row.partCode,
        partName: row.partName,
        partType: row.partType,
      };
      this.$refs.myDialog.dialogVisible = true;
    },
    // 确认新建/修改
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          if (title == "新建联想配件编码") {
            const res = await apiLenovoPartCodeAdd({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.onSearch();
              this.$message({ message: "新建成功", type: "success" });
            }
          } else if (title == "修改联想配件编码") {
            const res = await apiLenovoPartCodeUpdate({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.onSearch();
              this.$message({ message: "修改成功", type: "success" });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确认删除该记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await apiLenovoPartCodeDelete({ id: row.id });
        if (res.code == 0) {
          this.onSearch();
          this.$message({ message: '删除成功', type: 'success' });
        }
      }).catch(() => {});
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.onSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.onSearch();
    },
    // 表格导出
    tableExport() {
      this.$confirm(`导出数据可能需要几分钟的时间，确定导出吗？`, "导出列表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiLenovoPartCodeExport({
          ...this.lenovoPartCodeSearchForm,
        });
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.lenovoPartCode {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
